import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=076cd868&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076cd868",
  null
  
)

export default component.exports